export function initHeaderAnimation() {
	const header = document.getElementById( 'site-header' );
	if ( ! header ) return;

	const row      = header.querySelector( '.row' );
	const logo     = header.querySelector( '.site-header__logo' );
	const navItems = header.querySelectorAll( '.site-header__menu > li' );
	const actions  = header.querySelectorAll( '.site-header__action, .site-header__hamburger' );

	const updateHeaderState = () => {
		const scrolled = window.scrollY > 12;
		header.classList.toggle( 'is-scrolled', scrolled );
	};

	updateHeaderState();

	let ticking = false;
	const onScroll = () => {
		if ( ticking ) return;

		ticking = true;
		window.requestAnimationFrame( () => {
			updateHeaderState();
			ticking = false;
		} );
	};

	let resizeTimer;
	window.addEventListener('scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', () => {
		window.clearTimeout( resizeTimer );
		resizeTimer = window.setTimeout( updateHeaderState, 150 );
	}, { passive: true } );

	const gsap = window.gsap;
	if ( ! gsap || window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

	// Initial states
	if ( row ) gsap.set( row, { scaleX: 0.72, opacity: 0, transformOrigin: 'center center' } );
	if ( logo ) gsap.set( logo, { x: -12, opacity: 0 } );
	if ( navItems.length ) gsap.set( navItems, { y: -10, opacity: 0 } );
	if ( actions.length ) gsap.set( actions, { scale: 0.7, opacity: 0 } );

	const tl = gsap.timeline( { defaults: { ease: 'power3.out' }, delay: 0.05 } );

	if ( row ) tl.to( row, { scaleX: 1, opacity: 1, duration: 0.75 } );
	if ( logo ) tl.to( logo, { x: 0, opacity: 1, duration: 0.5 }, '-=0.45' );
	if ( navItems.length ) {
		tl.to( navItems, { y: 0, opacity: 1, duration: 0.45, stagger: 0.07 }, '-=0.35' );
	}
	if ( actions.length ) {
		tl.to( actions, { scale: 1, opacity: 1, duration: 0.35, stagger: 0.06, ease: 'back.out(1.4)' }, '-=0.3' );
	}
}
